import {
  FETCH_INTERVENTION_SUCCESS,
  UPDATE_INTERVENTION_TAGS_SUCCESS,
  EVALUATE_INTERVENTION_TAGS_SUCCESS,
} from 'modules/interventions/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {import("@arhs-fleetback/types/entities/tags").BasicTag[]} */
const initialState = [];

const onTagsChange = (_, { payload: { tags } }) => tags ?? [];

export default createReducer(initialState, {
  [FETCH_INTERVENTION_SUCCESS]: onTagsChange,
  [UPDATE_INTERVENTION_TAGS_SUCCESS]: onTagsChange,
  [EVALUATE_INTERVENTION_TAGS_SUCCESS]: onTagsChange,
});
